import { useHotkeys } from 'react-hotkeys-hook'

import { useCommandMenu } from '~/components/command-menu'
import { useAuth } from '~/context/AuthProvider'

export const useCmdkHotkey = () => {
  const { globalModalState, setGlobalModalState } = useAuth()
  const { activeView, setActiveView } = useCommandMenu()

  useHotkeys(
    'meta+k',
    () => {
      // close any dialogs that are open
      if (globalModalState.isOpen) {
        setGlobalModalState({
          /**
           * we don't set content to null here because if a txn dialog is open,
           * it will force the sidebar to go away for a brief moment.
           */
          ...globalModalState,
          isOpen: false,
        })
      }

      // toggle the command menu
      setActiveView(activeView ? null : 'default')
    },
    // preventDefault stops Firefox's native Cmd+K (focus web-search bar) from firing alongside the menu
    { preventDefault: true, enableOnFormTags: ['input', 'textarea', 'select'] },
  )

  return null
}
